<template>
  <v-navigation-drawer
    :value="isAddEditSidebarActive"
    temporary
    touchless
    :right="true"
    :width="$vuetify.breakpoint.smAndUp ? 450 : '100%'"
    app
    @input="(val) => $emit('update:is-add-edit-sidebar-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">{{ isEditMode ? 'Actualizar' : 'Agregar' }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-add-edit-sidebar-active',false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <!-- #### Email ############## -->
          <v-text-field
            v-model="itemData.email"
            outlined
            dense
            :rules="[validators.validateRequired]"
            :counter="50"
            label="Correo Electrónico"
            placeholder="Correo Electrónico"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### Password ############## -->
          <v-text-field
            v-model="itemData.password"
            outlined
            dense
            :rules="[validators.validateRequired, validators.validatePassword]"
            label="Contraseña"
            placeholder="Contraseña"
            :counter="20"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### Name ############## -->
          <v-text-field
            v-model="itemData.name"
            outlined
            dense
            :rules="[validators.validateRequired]"
            :counter="100"
            label="Nombre"
            placeholder="Nombre"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### Role ############## -->
          <v-text-field
            v-model="itemData.role"
            outlined
            dense
            :rules="[validators.validateRequired]"
            :counter="15"
            label="Perfil"
            placeholder="Perfil"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### Active ############## -->
          <v-switch
            v-model="itemData.active"
            inset
            :label="`${itemData.active ? 'Activo' : 'Inactivo'}`"
          ></v-switch>

          <v-btn
            :color="isEditMode ? 'info' : 'primary'"
            class="me-3"
            type="submit"
          >
            {{ isEditMode ? 'Actualizar' : 'Agregar' }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="resetItemData"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mdiClose, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { validateRequired, validatePassword } from '@core/utils/validation'
import store from '@/store'

export default {
  setup(props, { emit }) {
    const isEditMode = ref(false)

    const blankItemData = {
      userId: null,
      email: null,
      password: null,
      name: null,
      role: null,
      active: false,
      userKey: null,
    }

    const valid = ref(false)
    const form = ref(null)
    const isAddEditSidebarActive = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
      resetForm()
      isAddEditSidebarActive.value = false
      isEditMode.value = false
    }

    const onSubmit = () => {
      if (valid.value) {
        let mode = 'Insert'
        if (isEditMode.value === true) {
          mode = 'Update'
        }
        store.dispatch('users/apiCall', { mode, request: itemData.value }).then(result => {
          if (result.success) {
            emit('refetch-data')
            resetItemData()
          }
        })
      } else {
        validate()
      }
    }

    const ShowEditDialog = key => {
      if (key !== undefined) {
        store.dispatch('users/apiCall', { mode: 'Select', request: { key } }).then(result => {
          if (result.success) {
            itemData.value = result.data
            isAddEditSidebarActive.value = true
            isEditMode.value = true
          }
        })
      } else {
        isAddEditSidebarActive.value = true
        isEditMode.value = false
      }
    }

    return {
      isEditMode,
      resetItemData,
      form,
      onSubmit,
      itemData,
      valid,
      validate,
      ShowEditDialog,
      isAddEditSidebarActive,

      // validation
      validators: { validateRequired, validatePassword },
      icons: {
        mdiClose,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
</script>
